import React from "react"
import { LinkElement } from "./styles"

export default function Link({ disabled, action, text }) {
    return (
        <LinkElement onClick={disabled ? null : action} disabled={disabled}>{text}</LinkElement>
    )
}